import { useMemo, useState, useEffect } from "react"
import {
	Button,
	TextField,
	FormControlLabel,
	Checkbox,
	Typography,
	Container,
	IconButton,
	Input,
	InputLabel,
	InputAdornment,
	FormControl,
	Grow,
	FormHelperText,
	Box,
	Grid,
} from "@mui/material"
import { Alert } from "@mui/material"
import Visibility from "@mui/icons-material/Visibility"
import VisibilityOff from "@mui/icons-material/VisibilityOff"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Loader from "../../utils/Loader"
import Alerts from "../AlertMessage/AlertMessage"
import { signInValidate } from "./validate"
import { getUserParams, getOSVersion } from "../../helpers/browser"
import { MemberSolutionsButton } from "../../utils/Buttons"
import { getHistory } from "../../setup"
import Error from "../AlertMessage/ErrorPage"
import { handleImageError } from "../../helpers/imageErrorHandler"

const classes: any = {
	root: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		minHeight: "100vh",
		padding: "20px",
		boxSizing: "border-box",
	},
	paper: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		width: "100%",
		maxWidth: "400px",
	},
	form: {
		width: "100%",
		marginTop: 0,
		marginLeft: 0,
	},
	submit: {
		my: 3,
	},
	padding: {
		pt: 2,
	},
	headerText: {
		paddingTop: "20px",
		paddingBottom: "5px",
		marginBottom: "20px",
		borderBottom: `solid 2px`,
		borderColor: "secondary.main",
		textAlign: "center",
	},
	links: {
		paddingRight: "10px",
		paddingLeft: "10px",
		fontSize: "14px",
	},
	logo: {
		marginTop: 20,
	},
}

export interface Props {
	handleChange: (userName: string) => void
	onCheck: (checked: boolean) => void
	signIn: (username: string, password: string, checked: boolean) => void
	checked: boolean
}

function SignIn(props: any) {
	const { user, clearErrors, getClubDetails } = props
	const [errors, setErrors] = useState<any>({})
	const username = localStorage.getItem("username") || ""
	const path = localStorage.getItem("path") || null
	const params: any = useMemo(() => {
		return window.location.pathname.split("/")[1]
	}, [window.location.pathname])
	const userAgent = useMemo(() => getOSVersion(window), [])
	const [checked, setChecked] = useState(username ? true : false)
	const [values, setValues] = useState({
		userName: username,
		password: "",
		remember: checked,
		showPassword: false,
		requestIp: null,
		userAgent: userAgent,
	})

	useEffect(() => {
		clearErrors()
		getUserParams()
			.then((result: any) => {
				setValues((prevValues) => ({
					...prevValues,
					requestIp: result?.ip || "unknown",
				}))
			})
			.catch((errors: any) => {
				console.log(errors)
			})
		getClubDetails({ businessAlias: params, partnerApiKey: "mm" })
		const badge = document.querySelector(".grecaptcha-badge")
		if (badge) {
			;(badge as HTMLElement).style.display = "none"
		}
	}, [params])

	useEffect(() => {
		if (user) {
			getHistory().push(`/${params}/dashboard`)
		}
	}, [user])

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword })
	}

	const handleMouseDownPassword = (event: any) => {
		event.preventDefault()
	}

	const handleChange =
		(prop: any) => (event: React.ChangeEvent<HTMLInputElement>) => {
			setValues({ ...values, [prop]: event.target.value })
		}

	const clearMessage = () => {
		props.clearMessage()
	}

	const onCheck = () => {
		setChecked((prevChecked) => {
			const newChecked = !prevChecked
			setValues((prevValues) => ({ ...prevValues, remember: newChecked }))
			return newChecked
		})
	}

	const signIn = (e: any) => {
		e.preventDefault()
		clearMessage()
		let valid
		valid = signInValidate(values, setErrors)
		if (valid) {
			storeUsername(values.userName, values.remember)
			props.onSignIn(config)
		}
	}

	const storeUsername = (username: string, remember?: boolean) => {
		if (remember) {
			try {
				localStorage.setItem("username", username)
			} catch (e) {
				window.console.error(e)
			}
		} else {
			try {
				localStorage.removeItem("username")
			} catch (e) {
				window.console.error(e)
			}
		}
	}

	const config: any = {
		userName: values.userName,
		password: values.password,
		userAgent: values.userAgent,
		requestIp: values.requestIp,
		partnerApiKey: "mm",
		businessAlias: params,
		SystemName: "MP2",
		path: path,
	}

	return (
		<>
			{!props.clubData && props.clubDataSuccessful ? (
				<Error />
			) : (
				<Container maxWidth="xs" sx={classes.root}>
					<Box sx={classes.paper}>
						{props.clubData?.logoPath ? (
							<img
								src={props.clubData?.logoPath}
								width={180}
								alt="logo"
								style={classes.logo}
								onError={handleImageError}
							/>
						) : null}
						<Grow in={true} timeout={150}>
							<Typography sx={classes.headerText} component="h3" variant="h5">
								SIGN IN
							</Typography>
						</Grow>
						<Grow in={true} timeout={150}>
							<Typography style={{ fontSize: 16 }} component="h2" variant="h5">
								SIGN IN TO MEMBER PORTAL
							</Typography>
						</Grow>

						<form id="signin-form" style={classes.form} noValidate>
							<input type="hidden" value="something" />
							{!props.requesting ? (
								<div>
									<Grow in={true} timeout={150}>
										<TextField
											margin="normal"
											variant="standard"
											fullWidth
											aria-label="userName"
											id="userName"
											data-testid="userName"
											autoComplete="username"
											label={"Username"}
											name="userName"
											onChange={handleChange("userName")}
											autoFocus
											color="secondary"
											value={values.userName}
											error={errors.userName ? true : false}
											helperText={errors.userName}
										/>
									</Grow>
									<Grow in={true} timeout={300}>
										<FormControl color="secondary" sx={classes.form}>
											<InputLabel
												style={{
													marginBottom: 10,
													marginLeft: -13,
													marginTop: 8,
												}}
												htmlFor="standard-adornment-password"
												error={errors.password ? true : false}
											>
												Password
											</InputLabel>
											<Input
												id="standard-adornment-password"
												name="password"
												autoComplete="current-password"
												type={values.showPassword ? "text" : "password"}
												value={values.password}
												onChange={handleChange("password")}
												error={errors.password ? true : false}
												inputProps={{
													"data-testid": "password",
													style: { marginBottom: 5 },
												}}
												endAdornment={
													<InputAdornment position="end">
														<IconButton
															aria-label="toggle password visibility"
															onClick={handleClickShowPassword}
															onMouseDown={handleMouseDownPassword}
															size="large"
														>
															{values.showPassword ? (
																<Visibility />
															) : (
																<VisibilityOff />
															)}
														</IconButton>
													</InputAdornment>
												}
											/>
											<FormHelperText
												sx={{ ml: 0 }}
												error={errors.password ? true : false}
											>
												{errors.password}
											</FormHelperText>
										</FormControl>
									</Grow>
									<Grow in={true} timeout={450}>
										<FormControlLabel
											control={
												<Checkbox
													onChange={onCheck}
													data-testid="remember"
													checked={values.remember}
													color="secondary"
												/>
											}
											label={
												<span style={{ fontSize: "14px" }}>Remember Me</span>
											}
										/>
									</Grow>
								</div>
							) : (
								<Loader messages={props.messages} />
							)}

							<Alerts
								config={config}
								messages={props.messages}
								errors={props.errors || props.clubDataErrors}
								userMessages={props.userMessages}
							/>
							{props.signUpMessage ? (
								<Alert severity="success">{props.signUpMessage}</Alert>
							) : null}
							<Grow in={true} timeout={750}>
								<Button
									type="submit"
									fullWidth
									variant="contained"
									color="primary"
									sx={classes.submit}
									onClick={signIn}
									disabled={props.clubDataErrors ? true : false}
								>
									SIGN IN
								</Button>
							</Grow>
							<Grow in={true} timeout={600}>
								<Grid container justifyContent="center">
									<Grid>
										<Link
											style={classes.links}
											to={`/${params}/forgot/password`}
											color="primary"
											onClick={clearErrors}
										>
											Forgot Password
										</Link>
										|
									</Grid>
									<Grid>
										<Link
											style={classes.links}
											to={`/${params}/forgot/username`}
											color="primary"
											onClick={clearErrors}
										>
											Forgot Username
										</Link>
										|
									</Grid>
									<Grid>
										<a
											style={classes.links}
											href="https://membersolutions.com/privacy-policy/"
											color="primary"
											target="_blank"
											rel="noreferrer"
										>
											Privacy Policy
										</a>
									</Grid>
								</Grid>
							</Grow>
							<Grow in={true} timeout={750}>
								<Grid container justifyContent="center" direction={"column"}>
									<Typography
										variant="body2"
										component="h4"
										align="center"
										sx={classes.padding}
									>
										Not a Member?
										<Link
											style={classes.links}
											to={`/${params}/signup`}
											color="primary"
											onClick={clearErrors}
										>
											Sign Up
										</Link>
									</Typography>
									<Grid container justifyContent="center">
										<div style={{ paddingTop: 20 }}>
											<MemberSolutionsButton />
										</div>
									</Grid>
								</Grid>
							</Grow>
						</form>
					</Box>
				</Container>
			)}
		</>
	)
}

const mapStateToProps = (state: any) => {
	return {
		user: state.auth.currentUser,
		errors: state.auth.errors,
		messages: state.auth.messages,
		requesting: state.auth.requesting,
		userMessages: state.user.messages,
		signUpMessage: state.auth.signUpMessage,
		clubData: state.billingProfile.clubData,
		clubDataSuccessful: state.billingProfile.successful,
		clubDataErrors: state.billingProfile.errors,
	}
}

const mapDispatchToProps = (dispatch: any) => {
	return {
		onSignIn: (config: any) =>
			dispatch({ type: "LOGIN_REQUEST", value: config }),
		resendEmail: (config: any) =>
			dispatch({ type: "RESEND_EMAIL_REQUEST", value: config }),
		clearErrors: () => dispatch({ type: "CLEAR_ERROR" }),
		clearMessage: () => dispatch({ type: "CLEAR_MESSAGE" }),
		getClubDetails: (config: any) =>
			dispatch({ type: "ACCEPTED_CARDS_REQUEST", value: config }),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn)
